<template>
  <el-form-item :label="$attrs.label" :prop="$attrs.name" class="elsa-input" :ref="$attrs.name">
    <el-input v-bind="$attrs" v-model="modelProp" ref="input" v-on:blur="handleBlur" />
  </el-form-item>
</template>

<script>
export default {
  name: "ElsaInput",
  props: ["value"],
  computed: {
    modelProp: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      },
    },
  },
  methods: {
    setFocus() {
      this.$nextTick(() => {
        this.$refs.input.focus();
      });
    },
    handleBlur() {
      this.$emit("blur");
    },
  },
};
</script>

<style lang="scss" scoped>
.elsa-input {
  &::v-deep .el-input .el-input__inner {
    background: #ffffff;
    border: 1px solid #e6e6e6;
    box-sizing: border-box;
    border-radius: 8px;
    font-family: "SF Pro Display", sans-serif;
    font-size: 16px;
    line-height: 24px;
    color: #000000;
    opacity: 0.6;
    height: 52px;
  }
}

::v-deep .el-textarea textarea {
  background: #ffffff;
  border: 1px solid #e6e6e6;
  box-sizing: border-box;
  border-radius: 8px;
  font-family: "SF Pro Display", sans-serif;
  font-size: 16px;
  line-height: 24px;
  color: #121131;
  opacity: 1;
}
</style>
